import { render, staticRenderFns } from "./enterTest.vue?vue&type=template&id=97062db0&scoped=true&"
import script from "./enterTest.vue?vue&type=script&lang=js&"
export * from "./enterTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97062db0",
  null
  
)

export default component.exports